import { makeStyles } from '@material-ui/core/styles';

import { statusColors } from '../Constants/constants';

const useStyles = makeStyles((theme) => ({
  connection: {
    height: '1.1em',
    width: '1.1em',
    borderRadius: '50%',
    display: 'inline-block',
    margin: '1em'
  }
}));

export function ConnectionStatus({ slave }) {
  const classes = useStyles();
  return (
    <connection
      class={classes.connection}
      style={{
        backgroundColor:
          statusColors[
            slave.status === 'active' ? 'good' : slave.status === 'inactive' ? 'bad' : 'issues'
          ]
      }}
    ></connection>
  );
}
